import { render, staticRenderFns } from "./ProductZoomGalleryButton.vue?vue&type=template&id=7c297bae&scoped=true&"
import script from "./ProductZoomGalleryButton.vue?vue&type=script&lang=js&"
export * from "./ProductZoomGalleryButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductZoomGalleryButton.vue?vue&type=style&index=0&id=7c297bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c297bae",
  null
  
)

export default component.exports